import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class ModalPaymentService {
  public readonly modalState$: Subject<boolean>;

  static _() {
    return new ModalPaymentService();
  }

  constructor() {
    this.modalState$ = new Subject<boolean>();
  }

  public open() {
    this.modalState$.next(true);
  }

  public close() {
    this.modalState$.next(false);
  }
}
